import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import { RouteComponentProps } from "react-router-dom";

import ContainerBase from "lib/ContainerBase";

import { updateLineItems } from "state/actions/checkoutActions";
import { openMiniCart } from "state/actions/ui/miniCartUIactions";

import products from "state/selectors/products";

import ProductDetailView from "views/ProductDetailView";

import {
  GlobalState,
  Article,
  Products,
  Param,
  LineItems,
  Status
} from "types";
import { CheckoutReducer } from "state/reducers/checkout";

interface StoreProps {
  additionalReadings: Article[];
  products: Products | null;
  checkout: CheckoutReducer;
  updateLineItemsStatus: Status;
}

interface DispatchProps {
  actions: {
    updateLineItems(checkoutId: string, lineItems: LineItems): void;
    openMiniCart(): void;
  };
}

type Props = RouteComponentProps<Param> & StoreProps & DispatchProps;

class ProductDetailContainer extends ContainerBase<
  Props,
  typeof ProductDetailView
> {
  view = import("views/ProductDetailView");
}

const mapStateToProps = (state: GlobalState, props: Props) => {
  const productHandle = props.match.params.productHandle;
  const selectedProducts: Products | null = products(state);

  return {
    additionalReadings: state.applicationUI.globalSettings.additionalReadings,
    checkout: state.session.checkout,
    products: selectedProducts,
    product: selectedProducts && selectedProducts[productHandle],
    updateLineItemsStatus: state.status.updateLineItems
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      updateLineItems,
      openMiniCart
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDetailContainer);
